import type { VoiceChatParticipation } from 'generated/openapi';
import { type ReactNode } from 'react';
import { z } from 'zod';

import Handshake from '@/assets/icons/handshake.svg?react';
import Microphone from '@/assets/icons/microphone.svg?react';
import ShushingFace from '@/assets/icons/shushing-face.svg?react';
import SpeakerHighVolume from '@/assets/icons/speaker-high-volume.svg?react';

const voiceChatParticipationEnum = z.enum<VoiceChatParticipation[]>([
  'ALWAYS',
  'FRIENDS_ONLY',
  'SOMETIMES',
  'NEVER',
]);

export interface VoiceChatParticipationOption {
  id: VoiceChatParticipation;
  icon: ReactNode;
  label: string;
}

export const VOICE_CHAT_PARTICIPATION_MAP = new Map<
  VoiceChatParticipation,
  VoiceChatParticipationOption
>([
  [
    'ALWAYS',
    {
      id: 'ALWAYS',
      icon: <Microphone />,
      label: 'Mic always on',
    },
  ],
  [
    'FRIENDS_ONLY',
    {
      id: 'FRIENDS_ONLY',
      icon: <Handshake />,
      label: 'Duo only',
    },
  ],
  [
    'SOMETIMES',
    {
      id: 'SOMETIMES',
      icon: <SpeakerHighVolume />,
      label: 'Sometimes',
    },
  ],
  [
    'NEVER',
    {
      id: 'NEVER',
      icon: <ShushingFace />,
      label: 'Never (Text-only)',
    },
  ],
]);

export const VOICE_CHAT_PARTICIPATION_OPTIONS: VoiceChatParticipationOption[] =
  Array.from(VOICE_CHAT_PARTICIPATION_MAP.values());

export const VOICE_CHAT_PARTICIPATION_LABELS: Record<
  VoiceChatParticipation,
  string
> = {
  ALWAYS: 'Mic always on',
  FRIENDS_ONLY: 'Duo only',
  SOMETIMES: 'Sometimes',
  NEVER: 'Never (Text-only)',
};

export const voiceChatParticipationSchema = voiceChatParticipationEnum;
